<div class="container container-main">
  <div class="row">
    <div class="col-12">
      <h1>AI Assistant</h1>
      <p>This is a beta preview of AI.</p>
      <app-glai></app-glai>
    </div>
  </div>
</div>
